import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'odq-maintenance-page',
    templateUrl: './maintenance-page.component.html',
    styleUrls: ['./maintenance-page.component.scss'],
    standalone: false
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
